import React, { useEffect, useState } from 'react'
import moment from 'moment/moment'
import {
  DataGridPremium,
  esES,
  GridColDef, GridRenderCellParams,
} from '@asf-libs/x-data-grid-premium'
import Box from '@mui/material/Box'
import { getMaintenancesByUnitId } from '../../../api/MaintenancesApi'
import {MAINT_TYPE_SERVICE} from "../../../utils/generalConstants";
import IconButton from "@mui/material/IconButton";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import {useNavigate} from "react-router-dom";

const getColumns = (type, handleRowClick) => {
  let oColumns = [
    {
      field: 'idTicket',
      headerName: 'Orden de reparación ',
      minWidth: 140
    },
    {
      field: 'date',
      headerName: 'Fecha Finalización',
      minWidth: 140
    },
    {
      field: 'workshop',
      headerName: 'Taller',
      minWidth: 120
    },
    {
      field: 'status',
      headerName: 'Estado',
      width: 100
    },


  ];
  if(type !== MAINT_TYPE_SERVICE) {
    oColumns.unshift({
      field: 'type',
      headerName: 'Tipo',
      headerClassName: 'super-app-theme--header',
      align: 'center',
      minWidth: 130
    })
  }
  oColumns.unshift({
    field: 'edit',
    headerName: '',
    width: 40,
    renderCell: (params) => (
      <strong>
        <IconButton className="primary text" size="small" tabIndex={params.hasFocus ? 0 : -1} onClick={()=> handleRowClick(params.row.id)} >
          <BuildOutlinedIcon />
        </IconButton>
      </strong>
    ),
  },)
  return oColumns
}
const ConsultService = (props) => {
  const { id, domain, type } = props
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [id])

  async function fetchData() {
    setLoading(true)
    await getMaintenancesByUnitId(id, type)
      .then((response) => {
        const dataRows = response?.data?.map((d, index) => {
          return {
            id: d.id,
            numberPlate: domain,
            idTicket: d.idTicket,
            userID: d.userID,
            type: d.type,
            status: d.status,
            workshop: d.workshop,
            date: d.finishDate ? moment(d.finishDate).format('DD-MM-YYYY') : '',
          }
        })
        setRows(dataRows ? dataRows : [])
        setLoading(false)
      })
      .catch((e) => {
        console.log('Error', e)
      })
  }
  const handleRowClick = (params) => {
    navigate(`/web/maintenance-view/${params}`)
  }
  return (
    <Box
      borderRadius={5}
      sx={{
        background: '#FFFFFF',
        height: (rows?.length + 1) * 50 + 100,
      }}
    >
      <DataGridPremium
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        rows={rows}
        columns={getColumns(type[0], handleRowClick)}
        loading={loading}
        density="compact"
      />
    </Box>
  )
}

export default ConsultService
